<template>
  <div>
    <div v-loading="loading">
      <el-descriptions border size="small" :labelStyle="{ width: '100px' }">
        <el-descriptions-item :label="$l('form_label_orderNo') || '订单编号'">
          {{ formData.orderNo || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_custOrderNo') || '客户订单编号'"
        >
          {{ formData.custOrderNo || '' }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_orderType') || '订单类型'">
          {{ formData.v_orderType || '' }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_cust') || '下单客户'">
          {{ formData.custName || '' }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_endCust') || '终端客户'">
          {{ formData.endCustName || '' }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_brand') || '品牌'">
          {{ formData.brandName || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_salesPerson') || '业务人员'"
        >
          {{ formData.salesPersonName || '' }}
        </el-descriptions-item>
        <el-descriptions-item :label="$l('form_label_bizPerson') || '跟单人员'">
          {{ formData.bizPersonName || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_orderExecuteType') || '执行方式'"
        >
          {{ formData.v_orderExecuteType || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_quotedMethod') || '报价方式'"
        >
          {{ formData.v_quotedMethod || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_factoryPaymentTerms') || '工厂付款条件'"
        >
          {{ formData.v_factoryPaymentTerms || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_deliveryDay') || '交货日期'"
        >
          {{ formData.deliveryDay || '' }}
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_orderRemark') || '订单备注'"
        >
          {{ formData.orderRemark || '' }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <OrderGoods
      class="mt-4"
      ref="orderGoods"
      :noticeOrderCode="noticeOrderCode"
      :order="formData"
      :disabled="formData.noticeOrderStatus != 'Y'"
      @reload="$emit('reload')"
      @close="$emit('close')"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import OrderGoods from '../order-goods'
export default {
  mixins: [EditLoading],
  components: { OrderGoods },
  props: { noticeOrderCode: { type: String, default: '' } },
  data() {
    return {
      loading: false,
      formData: {},
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.noticeOrderCode) return
      this.loading = true
      const res = await this.$api
        .noticeOrderDetailApi({
          noticeOrderCode: this.noticeOrderCode,
        })
        .catch(() => {})
      this.loading = false
      this.formData = res.body || {}
    },
  },
}
</script>
